import type { ReactElement } from 'react';
import { AppBootstrap } from './AppBootstrap';
import { Auth0ProviderWrapper } from './Auth0Provider';

export function AuthInitializer({ children }: { children: ReactElement }): JSX.Element {
  return (
    <Auth0ProviderWrapper
      renderFn={(token) =>
        token ? <AppBootstrap token={token}>{children}</AppBootstrap> : children
      }
    />
  );
}
